export default __webpack_public_path__ + "b92b1ac6098b17a18da423ff18842882.png";